import { GetRequest, PutRequest, PutRequestImpersonator } from "./RequestTemplates";

export type UserT = {
  id: string;
  regWsFlag?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

export const getUser = async (id: string): Promise<UserT> => {
  return GetRequest(`${process.env.API_SERVER_URL}/users/${id}`).then((res) => res.data);
};

export function updateUser(userId: string, userUpdate: UserT, impersonator_token: string | undefined) {
  if (impersonator_token) {
    return PutRequestImpersonator(
      `${process.env.API_SERVER_URL}/users/impersonation/${userId}`,
      userUpdate,
      undefined,
      undefined,
      impersonator_token
    ).then((res) => res.data);
  } else {
    return PutRequest(`${process.env.API_SERVER_URL}/users/${userId}`, userUpdate).then((res) => res.data);
  }
}
